<div class="row">
  <div class="col-sm-12">
    <div class="container_tab_nav">

      <!-- Tablist -->
      <ul class="nav nav-tabs two" role="tablist" aria-label="Gestione adempimenti">
        <li class="tab-link-nav" [style.width.%]="50">
          <button
            type="button"
            role="tab"
            class="btn-link"
            id="tab-lista-adempimenti"
            [attr.aria-selected]="currentTab === tabs.LIST"
            [attr.aria-controls]="'tabpanel-lista-adempimenti'"
            [class.active]="currentTab === tabs.LIST"
            [class.inactive]="currentTab !== tabs.LIST"
            (click)="setTab(tabs.LIST)"
          >
            Lista adempimenti inseriti
          </button>
        </li>

        <li class="tab-link-nav" [style.width.%]="50">
          <button
            type="button"
            role="tab"
            class="btn-link"
            id="tab-crea-adempimenti"
            [attr.aria-selected]="currentTab === tabs.CREATE"
            [attr.aria-controls]="'tabpanel-crea-adempimenti'"
            [class.active]="currentTab === tabs.CREATE"
            [class.inactive]="currentTab !== tabs.CREATE"
            (click)="setTab(tabs.CREATE)"
          >
            Crea nuovo adempimento
          </button>
        </li>
      </ul>

      <!-- Tab panels -->
      <div class="tab-content">

        <!-- Pannello Lista -->
        <div
          role="tabpanel"
          id="tabpanel-lista-adempimenti"
          [attr.aria-labelledby]="'tab-lista-adempimenti'"
          *ngIf="currentTab == tabs.LIST"
        >
          <step-adempimenti-list 
            *ngIf="scadenze && scadenze.length > 0"
            [fascicolo]="fascicolo" 
            [scadenze]="scadenze" 
            (editEvent)="editScadenza($event)" 
            (onDropDownEvent)="onDropDownEvent($event)" 
            (onDocumentEvent)="onDocumentEvent($event)"
            (deleteEvent)="onDeleteScadenza($event)"
          >
          </step-adempimenti-list>
        </div>

        <!-- Pannello Crea -->
        <div
          role="tabpanel"
          id="tabpanel-crea-adempimenti"
          [attr.aria-labelledby]="'tab-crea-adempimenti'"
          *ngIf="currentTab == tabs.CREATE"
        >
          <step-adempimenti-form
            [scadenza]="scadenzaTmp"
            (adempimentoChange)="onEmitAdempimentoSubmit($event)"
          >
          </step-adempimenti-form>
        </div>

      </div>
    </div>
  </div>
</div>


<div [attr.id]="'docAddModalScadenze'" style="width: 100%;height: 100vh;margin: 0px;"
	doc_add_modal #docAddModalScadenze [fascicolo]="fascicolo"
	(onReturn)="closeModalDocumentAndReadSezione()">
</div>

<div modale_rinvio_scadenza [attr.id]="'modalrinvioscad'"
	(onReturn)="setScadenza($event)" #modaleRinvioScadenza>
</div>

<div doc_version_update_modal  #docVersionUpdateModalScadenze [attr.id]="'docVersionUpdateModalScadenze'" [fascicolo]="fascicolo" (onReturn)="closeModalDocumentAndReadSezione()" style="width: 80%;"></div>

<div doc_version_history_modal #docVersionHistoryScadenze [tipoPratica]="fascicolo?.praticaBase?.tipoPratica.id" [attr.id]="'docVersionHistoryScadenze'"></div>


<div modale_aggiungi_scadenza_auto [attr.id]="'adempimentiScadenzaAutoAddModal'" (onReturn)="closeModalDocumentAndReadSezione()" [isAtto]="true"
    #adempimentiScadenzaAutoAddModal></div>
<dettaglio-adempimento-mod #esitoAddModal [attr.id]="'modalDettaglioAdempimento'" (onReturn)="closeModalDocumentAndReadSezione()"></dettaglio-adempimento-mod>
<!-- <div class="row wizard-buttons">
  <p class="col-sm-3 col-xs-6">
    <button type="button" class="btn btn-outline-secondary btn-block" (click)="reset()">Reset</button>
  </p>
  <p
    class="col-sm-3 col-xs-6 col-sm-offset-6">
    <button type='button' class='btn btn-primary btn-block' (click)="salva()">
      Salva
    </button>
  </p>
</div> -->
